import { render, staticRenderFns } from "./AuthCallback.vue?vue&type=template&id=f95cdbee&scoped=true&"
import script from "./AuthCallback.vue?vue&type=script&lang=ts&"
export * from "./AuthCallback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95cdbee",
  null
  
)

export default component.exports